// extracted by mini-css-extract-plugin
module.exports = {"addDate":"AddDate_addDate__2erH2"};